module.exports = __webpack_public_path__ + "static/media/ar.6a2c6670.svg";